import React from "react";

const BlogBody = () => {
  return (
    <div className="blog_body py-4 px-4 border-b mb-4">
      <div className="blog_body_container container mx-auto lg:px-20 text-textSecondary-900">
        {/* Subheader */}
        <div className="subhader">
          <p className="leading-6 font-medium text-lg lg:text-2xl text-textPrimary-900">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident
            incidunt similique, veniam aliquam vitae id labore! Dolorem vitae
            illum
          </p>
        </div>

        {/* Content */}
        <div className="content my-8">
          <div className="contentPart1 my-6">
            <p className="leading-8 lg:text-base text-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus
              praesentium porro obcaecati sed sequi expedita illo possimus
              dolorem voluptas quo commodi debitis voluptatem officiis
              laboriosam laborum ab, numquam aperiam placeat neque aliquam
              molestiae mollitia cumque cum? Aliquid commodi possimus
              reiciendis? Labore reprehenderit possimus doloribus dignissimos,
              omnis corporis dolorem! Doloribus, vitae nulla earum sequi ipsa
              voluptatibus et accusantium aliquid iure, optio possimus
              laudantium facere quaerat obcaecati eaque pariatur veniam
              perferendis mollitia quod maiores est vero assumenda placeat! Sint
              tempora blanditiis vel autem debitis, harum unde aliquid illum sed
              alias ex maxime, minima laudantium earum explicabo, aut vitae
              corrupti vero. Molestias debitis quibusdam quia facilis nostrum
              iure ipsum sit, minus, nulla reprehenderit pariatur expedita sunt
              cum, dolor fugit quasi totam. Quasi, maiores! Quo doloremque,
              tempora exercitationem cumque eligendi optio eveniet, cum,
              cupiditate quam maiores numquam labore harum dolores distinctio
              animi sequi dignissimos quisquam corrupti aut necessitatibus
              quibusdam officia aspernatur? Quo rem ullam maiores dicta
              deleniti, repudiandae magni ad natus itaque recusandae molestias
              exercitationem adipisci harum voluptatem sint perferendis animi
              unde illum velit totam! Culpa dolorem saepe earum, laboriosam
              quae, quod tempora voluptate recusandae natus ratione nulla autem
              aspernatur, blanditiis magnam debitis excepturi in aliquid nostrum
              odit veniam. Expedita vel dolor ipsam nihil deleniti aspernatur?
              Nihil aspernatur magni obcaecati, rerum, nesciunt consequatur
              explicabo cum voluptatem ipsa expedita dolor nisi laudantium
              voluptates corrupti repudiandae, quae minima in fugiat
              voluptatibus corporis iure saepe. Fugit delectus laboriosam, ipsam
              eum ex voluptate dignissimos commodi ab? Maxime, sint commodi amet
              fugiat tempora laborum quas id eligendi qui autem voluptas earum
              inventore quasi perferendis sed fuga sapiente, quisquam
              necessitatibus. Suscipit tempore aperiam vero. Quibusdam voluptas
              tenetur ex veritatis non beatae quod voluptates eveniet, maiores
              atque magni quaerat corrupti reprehenderit doloremque, cupiditate
              distinctio illo eaque, soluta est rem nisi? Excepturi tenetur a
              suscipit quasi odio facere molestiae ratione vitae totam.
            </p>
          </div>
          {/* Image Div */}

          <div className="w-full">
            <img
              src="https://images.pexels.com/photos/2857306/pexels-photo-2857306.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt=""
              className="h-96"
            />
          </div>

          <div className="contentPart2 my-6">
            <p className="leading-8 lg:text-base text-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus
              praesentium porro obcaecati sed sequi expedita illo possimus
              dolorem voluptas quo commodi debitis voluptatem officiis
              laboriosam laborum ab, numquam aperiam placeat neque aliquam
              molestiae mollitia cumque cum? Aliquid commodi possimus
              reiciendis? Labore reprehenderit possimus doloribus dignissimos,
              omnis corporis dolorem! Doloribus, vitae nulla earum sequi ipsa
              voluptatibus et accusantium aliquid iure, optio possimus
              laudantium facere quaerat obcaecati eaque pariatur veniam
              perferendis mollitia quod maiores est vero assumenda placeat! Sint
              tempora blanditiis vel autem debitis, harum unde aliquid illum sed
              alias ex maxime, minima laudantium earum explicabo, aut vitae
              corrupti vero. Molestias debitis quibusdam quia facilis nostrum
              iure ipsum sit, minus, nulla reprehenderit pariatur expedita sunt
              cum, dolor fugit quasi totam. Quasi, maiores! Quo doloremque,
              tempora exercitationem cumque eligendi optio eveniet, cum,
              cupiditate quam maiores numquam labore harum dolores distinctio
              animi sequi dignissimos quisquam corrupti aut necessitatibus
              quibusdam officia aspernatur? Quo rem ullam maiores dicta
              deleniti, repudiandae magni ad natus itaque recusandae molestias
              exercitationem adipisci harum voluptatem sint perferendis animi
              unde illum velit totam! Culpa dolorem saepe earum, laboriosam
              quae, quod tempora voluptate recusandae natus ratione nulla autem
              aspernatur, blanditiis magnam debitis excepturi in aliquid nostrum
              odit veniam. Expedita vel dolor ipsam nihil deleniti aspernatur?
              Nihil aspernatur magni obcaecati, rerum, nesciunt consequatur
              explicabo cum voluptatem ipsa expedita dolor nisi laudantium
              voluptates corrupti repudiandae, quae minima in fugiat
            </p>
          </div>
          <div className="contentPart3 my-6">
            <p className="leading-8 lg:text-base text-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus
              praesentium porro obcaecati sed sequi expedita illo possimus
              dolorem voluptas quo commodi debitis voluptatem officiis
              laboriosam laborum ab, numquam aperiam placeat neque aliquam
              molestiae mollitia cumque cum? Aliquid commodi possimus
              reiciendis? Labore reprehenderit possimus doloribus dignissimos,
              omnis corporis dolorem! Doloribus, vitae nulla earum sequi ipsa
              voluptatibus et accusantium aliquid iure, optio possimus
              laudantium facere quaerat obcaecati eaque pariatur veniam
              perferendis mollitia quod maiores est vero assumenda placeat! Sint
              tempora blanditiis vel autem debitis, harum unde aliquid illum sed
              alias ex maxime, minima laudantium earum explicabo, aut vitae
              corrupti vero. Molestias debitis quibusdam quia facilis nostrum
              iure ipsum sit, minus, nulla reprehenderit pariatur expedita sunt
              cum, dolor fugit quasi totam. Quasi, maiores! Quo doloremque,
              tempora exercitationem cumque eligendi optio eveniet, cum,
              cupiditate quam maiores numquam labore harum dolores distinctio
              animi sequi dignissimos quisquam corrupti aut necessitatibus
            </p>
          </div>

          <div className="video flex gap-4">
            <div className="project__video w-full">
              <iframe
                className="w-full h-56"
                src="https://www.youtube.com/embed/JRQei9hJekc"
                title="32Stitches & CHENDA, Harley Bird - Freedom [NCS Release]"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="project__video w-full">
              <iframe
                className="w-full h-56"
                src="https://www.youtube.com/embed/JRQei9hJekc"
                title="32Stitches & CHENDA, Harley Bird - Freedom [NCS Release]"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="contentPart4 my-6">
            <p className="leading-8 font-semibold lg:text-base text-sm">
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus
              praesentium porro obcaecati sed sequi expedita illo possimus
              dolorem voluptas quo commodi debitis voluptatem officiis
              laboriosam laborum ab, numquam aperiam placeat neque aliquam
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogBody;
